import baseAPI from '@/api';
import { Tile } from '@/models/tiles';
import { QueryFunctionContext } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { UseGameRoundTilesQueryKey } from './props';

export async function fetchGameRoundTiles({
  queryKey,
}: QueryFunctionContext<UseGameRoundTilesQueryKey>): Promise<Tile[]> {
  try {
    const { roundId } = queryKey[1];

    const response: AxiosResponse<Tile[]> = await baseAPI.get<Tile[]>(
      `/game-rounds/tiles/${roundId}`,
    );

    return response.data;
  } catch (error) {
    return undefined;
  }
}
